var __assign = this && this.__assign || function () {
  return (__assign = Object.assign || function (t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      for (var i in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    __rest = this && this.__rest || function (t, e) {
  var n = {};

  for (i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) for (var r = 0, i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
    e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
  }
  return n;
};

import React, { useContext, useEffect, useLayoutEffect, useRef } from "react";
import { MathJaxBaseContext } from "../MathJaxContext";

var typesettingFailed = function typesettingFailed(t) {
  return "Typesetting failed: ".concat(void 0 !== t.message ? t.message : t.toString());
},
    MathJax = function MathJax(t) {
  function r() {
    var t;
    "every" === h && m && "post" === v && null !== f.current && (f.current.style.visibility = null != (t = null == (t = p.style) ? void 0 : t.visibility) ? t : "visible"), _.current || ("first" === h && null !== f.current && (f.current.style.visibility = "visible"), n && n(), _.current = !0), o && o(), b.current = !1;
  }

  var e = t.inline,
      i = void 0 !== e && e,
      e = t.hideUntilTypeset,
      n = t.onInitTypeset,
      o = t.onTypeset,
      s = t.text,
      u = t.dynamic,
      a = t.typesettingOptions,
      l = t.renderMode,
      c = t.children,
      p = __rest(t, ["inline", "hideUntilTypeset", "onInitTypeset", "onTypeset", "text", "dynamic", "typesettingOptions", "renderMode", "children"]),
      y = useRef(""),
      f = useRef(null),
      d = useContext(MathJaxBaseContext),
      h = null != e ? e : null == d ? void 0 : d.hideUntilTypeset,
      v = null != l ? l : null == d ? void 0 : d.renderMode,
      g = null != a ? a : null == d ? void 0 : d.typesettingOptions,
      m = !1 !== u && (u || "production" !== process.env.NODE_ENV),
      _ = useRef(!1),
      b = useRef(!1);

  return !b.current && null !== f.current && m && "every" === h && "post" === v && (f.current.style.visibility = "hidden"), ("undefined" != typeof window ? useLayoutEffect : useEffect)(function () {
    if ((m || !_.current) && null !== f.current) {
      if (!d) throw Error("MathJax was not loaded, did you use the MathJax component outside of a MathJaxContext?");

      if ("pre" === v) {
        if (!("string" == typeof (t = s) && 0 < t.length)) throw Error("Render mode 'pre' requires text prop to be set and non-empty, which was currently \"".concat(s, '"'));
        if (!a || !a.fn) throw Error("Render mode 'pre' requires 'typesettingOptions' prop with 'fn' property to be set on MathJax element or in the MathJaxContext");
        if (2 === d.version) throw Error("Render mode 'pre' only available with MathJax 3, and version 2 is currently in use");
      }

      "post" !== v && s === y.current || b.current || (b.current = !0, 3 === d.version ? d.promise.then(function (e) {
        var n;
        "pre" === v ? (n = function n(t) {
          y.current = s, e.startup.document.clear(), e.startup.document.updateDocument(), null !== f.current && (f.current.innerHTML = t.outerHTML), r();
        }, a.fn.endsWith("Promise") ? e.startup.promise.then(function () {
          return e[g.fn](s, __assign(__assign({}, (null == g ? void 0 : g.options) || {}), {
            display: !i
          }));
        }).then(n).catch(function (t) {
          throw r(), Error(typesettingFailed(t));
        }) : e.startup.promise.then(function () {
          var t = e[g.fn](s, __assign(__assign({}, (null == g ? void 0 : g.options) || {}), {
            display: !i
          }));
          n(t);
        }).catch(function (t) {
          throw r(), Error(typesettingFailed(t));
        })) : e.startup.promise.then(function () {
          return e.typesetClear([f.current]), e.typesetPromise([f.current]);
        }).then(r).catch(function (t) {
          throw r(), Error(typesettingFailed(t));
        });
      }).catch(function (t) {
        throw r(), Error(typesettingFailed(t));
      }) : d.promise.then(function (t) {
        t.Hub.Queue(["Typeset", t.Hub, f.current]), t.Hub.Queue(r);
      }).catch(function (t) {
        throw r(), Error(typesettingFailed(t));
      }));
    }

    var t;
  }), React.createElement("span", __assign({}, p, {
    style: __assign(__assign({
      display: i ? "inline" : "block"
    }, p.style), {
      visibility: h ? "hidden" : null == (t = p.style) ? void 0 : t.visibility
    }),
    ref: f
  }), c);
};

export default MathJax;